import React from 'react'
import { Button } from 'reactstrap'
// import { Button, Input, InputGroup, InputGroupAddon, InputGroupText, Label } from 'reactstrap'
import styled from 'styled-components'
import { BOOKINGS } from 'constants/index'
import { I18n } from 'react-redux-i18n'
import moment from 'moment'

const Container = styled.div`
  padding: 0 5px 0 0;
`

const DivItem = styled.div`
  display: inline;
  margin-left: 5px;
`

const actionList = (props) => {
  const { actions, getBookingAction } = props
  const getText = (type) => {
    const _type = BOOKINGS.actions[type] || type
    return I18n.t(_type)
  }
  const disabledButton = (limitDateUTC) => {
    if (!limitDateUTC) return true
    const currentDate = moment().utc()
    const limitDate = moment(limitDateUTC).utc()
    return currentDate.isSameOrAfter(limitDate)
  }
  return (
    <Container className='mt-5'>
      {actions.map((action, index) => (
        <DivItem key={index}>
          {action.type && (
            <Button onClick={() => getBookingAction(action)} color='primary' disabled={disabledButton(action.limitDateUTC)}>
              {getText(action.type)}
            </Button>
          )}
        </DivItem>
      ))}
    </Container>
  )
}

export default actionList
